<template>
  <div class="overflow-hidden" :class="containerClass">
    <slot></slot>
  </div>
</template>

<script lang="ts">
export type UIContainerProps = {
  fluid?: boolean;
  backgroundImage?: string;
};
</script>

<script lang="ts" setup>
import { computed } from "vue";

const props = defineProps<UIContainerProps>();

const containerClass = computed<string>(() =>
  props.fluid ? "container-fluid" : "container"
);
</script>
